/**
 * Configuration Candy Rack API
 * Documentation: https://help.digismoothie.com/en/articles/6460146-candy-rack-public-api-options-for-developers
 * 
 * IMPORTANT: Ce thème utilise des PAGES au lieu de TEMPLATES PRODUITS
 * Les produits sont affichés via page.metafields.custom.product.value
 * 
 * Candy Rack est déclenché au CHECKOUT (validation du panier)
 */

// 1. Sélecteurs personnalisés pour les boutons Checkout
// Candy Rack détectera uniquement les boutons de checkout avec l'attribut data-candyrack-trigger="true"
window.CANDYRACK_CUSTOM_BUTTON_SELECTORS = [
  '[data-candyrack-trigger="true"]'
];

// 2. Validation personnalisée avant d'afficher le popup au checkout
// Retourne true pour autoriser l'ouverture du popup, false pour l'empêcher
window.CANDYRACK_CAN_ATC = (button) => {
  return true;
};

// 3. Fonction pour obtenir l'ID de la variante au checkout
// Pour le checkout, Candy Rack utilise les produits du panier
window.CANDYRACK_VARIANT_SELECTOR_FUNCTION = (button) => {
  // Au checkout, Candy Rack récupère automatiquement les variantes du panier
  // Pas besoin de retourner une variante spécifique
  return undefined;
};

// ==========================================
// ÉVÉNEMENTS PERSONNALISÉS CANDY RACK
// ==========================================

document.addEventListener('addToCartButtonClicked', (e) => {
  // Événement: Bouton checkout cliqué dans le popup
});

document.addEventListener('candyrack-offer-added', (e) => {
  // Événement: Offre ajoutée au checkout
});

document.addEventListener('candyrack-offer-removed', (e) => {
  // Événement: Offre retirée
});

document.addEventListener('candyrack-closed', (e) => {
  // Événement: Popup fermé au checkout
  // Candy Rack gère automatiquement la redirection
});

document.addEventListener('ppp-candyrack-button-layout-offers-added-to-cart', (e) => {
  // Événement: Offres button layout ajoutées au panier
});

document.addEventListener('ppp-candyrack-checkbox-layout-offers-added-to-cart', (e) => {
  // Événement: Offres checkbox layout ajoutées au panier
});

document.addEventListener('ppp-candyrack-checkbox-layout-offer-checked', (e) => {
  // Événement: Offre cochée
});

document.addEventListener('ppp-candyrack-checkbox-layout-offer-unchecked', (e) => {
  // Événement: Offre décochée
});
